export default {
  async blockUserOnRepliess({ commit }, payload) {
    try {
      const { id, updatedData } = payload;

      const response = await fetch(`/api/posts/${id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedData),
      });

      if (!response.ok) {
        console.error(
          `Failed to update post with ID ${id}: ${response.statusText}`
        );
      }

      const data = await response.json();
      commit("SET_BLOCK_ON_REPLIES", data.id);
      return data;
    } catch (error) {
      console.error("Error updating post:", error);
      throw error;
    }
  },

  async getBlockList({ commit }, payload) {
    try {
      const res = await this.$api.block.getBlockList(payload);
      commit("setBlockList", res.data);
    } catch (error) {
      console.log(error);
    }
  },
};
